import { render, staticRenderFns } from "./dataQualityAssessment.vue?vue&type=template&id=243527bb&scoped=true"
import script from "./dataQualityAssessment.vue?vue&type=script&lang=js"
export * from "./dataQualityAssessment.vue?vue&type=script&lang=js"
import style0 from "./dataQualityAssessment.vue?vue&type=style&index=0&id=243527bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243527bb",
  null
  
)

export default component.exports